module.exports = __webpack_public_path__ + "img/682cc569eff54bdb80d151faa385ba6d.b1930975.png";